import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage.js';
import { OnboardingsListPage } from './pages/OnboardingsListPage.js';
import { OnboardingDetailPage } from './pages/OnboardingDetailPage.js';
import { NewOnboardingPage } from './pages/NewOnboardingPage.js';
import { ProtectedLayout } from './components/ProtectedLayout.js';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedLayout />}>
        <Route path="/onboardings" element={<OnboardingsListPage />} />
        <Route path="/onboardings/new" element={<NewOnboardingPage />} />
        <Route path="/onboardings/:id" element={<OnboardingDetailPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/onboardings" replace />} />
    </Routes>
  );
}
